import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationForStudent(id: string): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>(`/aluno/recomendacao/?student_id=${id}`, {});
  return data;
}

type QueryFnType = typeof getConsolidationForStudent;

function useConsolidationForStudent(id) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-for-student', id],
    queryFn: () => getConsolidationForStudent(id),
  });
}

export { getConsolidationForStudent, useConsolidationForStudent };
